import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function MicrosoftCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setUser, setToken } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    const email = searchParams.get('email');
    const error = searchParams.get('error');

    if (error) {
      console.error('Microsoft OAuth error:', error);
      navigate('/login?error=' + encodeURIComponent(error));
      return;
    }

    if (token) {
      console.log('Microsoft login successful, storing token');
      localStorage.setItem('token', token);
      setToken(token);
      
      // Fetch user data
      const fetchUserData = async () => {
        try {
          const response = await fetch(
            `${process.env.NODE_ENV === 'development' 
              ? 'http://localhost:3000' 
              : (process.env.REACT_APP_API_URL || window.location.origin.replace(':81', ':3000'))}/api/auth/me`,
            {
              headers: {
                'Authorization': `Bearer ${token}`
              }
            }
          );
          
          if (response.ok) {
            const userData = await response.json();
            setUser(userData);
            navigate('/dashboard');
          } else {
            throw new Error('Failed to fetch user data');
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
          navigate('/login?error=' + encodeURIComponent('Failed to complete login'));
        }
      };

      fetchUserData();
    } else {
      console.error('No token received from Microsoft OAuth');
      navigate('/login?error=' + encodeURIComponent('Authentication failed'));
    }
  }, [searchParams, navigate, setUser, setToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 to-gray-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500 mx-auto"></div>
        <p className="mt-4 text-gray-600">Completing sign in...</p>
      </div>
    </div>
  );
}

export default MicrosoftCallback;

